import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { Observable, map } from 'rxjs';
import { FilterState } from '@ui/shared/domain-filter';
import { FilterOption } from '@ui/shared/util-filter';
import { BaseFilterWithOptionsComponent } from '../base-filter-with-options/base-filter-with-options.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-dropdown-filter',
    templateUrl: './dropdown-filter.component.html',
    styleUrls: ['./dropdown-filter.component.scss', '../filter-element/filter-element.component.scss'],
    imports: [
        CommonModule,
        FormsModule,
        Select,
    ],
})
export class DropdownFilterComponent extends BaseFilterWithOptionsComponent {
    @ViewChild(Select)
    public dropdown?: Select;

    public readonly value$: Observable<FilterOption | null>;

    constructor(
        activeFilterService: FilterState,
    ) {
        super(activeFilterService);

        this.value$ = this.limitedValues$
            .pipe(
                map(values => values[0] ?? null),
            );

        activeFilterService.closeAllOverlays$
            .pipe(
                takeUntilDestroyed(),
            )
            .subscribe(() => {
                this.dropdown?.hide();
            });
    }

}
